<template>
  <div class="text-align-end" :class="layoutClass">
    <b-button variant="outline-deep-green" :size="btnSize" :class="['reset-btn-hover', `${ btnSize === 'sm' ? 'me-2' : 'me-3' }`, resetBtnClass]"  @click="resetFn">
      <i class="fas fa-redo icon-padding-right ct-mb-padding-left-25 align-middle" />
      <span :class="`${ btnSize === 'sm' ? '' : 'd-none d-sm-inline-block' } align-middle`">초기화</span>
    </b-button>
    <b-button variant="deep-green" :size="btnSize" :class="searchBtnClass" @click="searchFn">
      <i class="fas fa-search icon-padding-right ct-mb-padding-left-25 align-middle" />
      <span :class="`${ btnSize === 'sm' ? '' : 'd-none d-sm-inline-block' }`">조회</span>
    </b-button>
  </div>
</template>

<script>
export default {
  name: "searchButtons",
  props: {
    layoutClass: String,
    btnSize: String,
    resetBtnClass: String,
    searchBtnClass: String,
    resetFn: Function,
    searchFn: Function,

  }
}
</script>